import { Pipe, PipeTransform } from '@angular/core';
import { UAParser } from 'ua-parser-js';

@Pipe({
    name: 'useragent',
    standalone: false
})
export class UseragentPipe implements PipeTransform {
  transform(value: string, field: string): string {
    const parser = new UAParser(value);

    const results = parser.getResult();

    switch (field) {
      case 'browser':
        return (
          `${results?.browser?.name} v${results.browser.version
            .split('.')
            .at(0)}` || value
        );
      case 'browsername':
        return results?.browser?.name || value;
      case 'os':
        return results?.os?.name || value;
      case 'device':
        return results?.device?.type || value;
      default:
        return value;
    }
  }
}
